<template>
  <div class="upload-content pcStyle">
    <van-uploader
      v-model="uploadList"
      :max-count="1"
      :after-read="OnAfterRead"
      :before-read="onBeforeRead"
      :max-size="20 * 1024 * 1024"
      :preview-full-image="false"
      accept="image/jpg, image/jpeg, image/png, .pdf"
      @oversize="onOversize"
      @delete="deleteOneImg"
      @click-preview="previewImage"
    >
      <div class="upload-default-box">
        <img class="upload-default-icon" src="@/assets/images/upload-icon.png" alt="" />
        <div class="upload-default-text">{{ i18n.independentMarketing.uploadPic }}</div>
      </div>
      <template #preview-cover="{ file }">
        <div v-if="file.type === 'application/pdf'" class="proview-cover">
          <img src="@/assets/images/pdf.png" alt="" />
          <div class="file-name" :title="file.name">{{ file.name }}</div>
        </div>
      </template>
    </van-uploader>
  </div>
</template>
<script>
  import { ImagePreview } from 'vant';
  import { uploadListApi } from '@/api/independentMarketing.js';
  export default {
    data() {
      return {
        uploadList: [],
        pathList: [],
      };
    },
    methods: {
      OnAfterRead(file) {
        if (!file) return;
        let fileFormData = new FormData();
        fileFormData.append('file', file.file);
        file.status = 'uploading';
        uploadListApi(fileFormData)
          .then(res => {
            const { data, code } = res;
            if (code == 200 && data?.path) {
              file.status = 'success';
              this.pathList.push({
                url: data.path,
                id: data.id,
                isImage: true,
              });
            } else {
              file.status = 'failed';
              this.pathList.push({});
              this.$showToast(this.i18n.independentMarketing.agreement.getAgreementFailed);
            }
          })
          .catch(err => {
            this.pathList.push({});
            file.status = 'failed';
            this.$showToast(err?.message || this.i18n.independentMarketing.agreement.getAgreementFailed);
          })
          .finally(() => {
            this.emitUploadEvent();
          });
      },
      onBeforeRead(file) {
        console.log(file.type);
        return ['application/pdf', 'image/jpg', 'image/jpeg', 'image/png'].includes(file.type);
      },
      previewImage(file) {
        if (!file) return;
        if (file.file.type === 'application/pdf') {
          window.open(this.pathList[0].url);
        } else {
          ImagePreview({
            images: [this.pathList[0].url],
            showIndex: false,
            closeOnPopstate: true,
            closeable: true,
          });
        }
      },
      onOversize() {
        this.$toast(this.i18n.independentMarketing.picMaxLimit);
      },
      deleteOneImg(detail) {
        this.pathList.splice(detail.index, 1);
        this.emitUploadEvent();
      },
      emitUploadEvent() {
        this.$emit('uploadChange', this.pathList);
      },
    },
  };
</script>
<style lang="less" scoped>
.upload-content.pcStyle {
  display: flex;
  align-items: center;
  /deep/ .van-uploader__preview {
    margin-bottom: 0;
    margin-right: 7px;
  }
  .upload-default-box {
    width: 112px;
    height: 84px;
    border-radius: 4px;
    background: #f5f5f5;
    border: 1px dashed #bebebe;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    margin-right: 7px;
    .box-content {
      font-size: 0;
      text-align: center;
    }
    .upload-default-icon {
      width: 20px;
      height: 20px;
    }
    .upload-default-text {
      margin-top: 8px;
      font-size: 14px;
      color: #888;
      line-height: 18px;
      text-align: center;
    }
  }

  .proview-cover {
    width: 100%;
    height: 100%;
    background: #f8f9fa;
    text-align: center;
    padding-top: 10px;
    font-size: 0;
    img {
      width: 30px;
    }
    .file-name {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 16px;
      color: #888;
    }
  }
}
</style>